import "../libs/spinner"
import getCropper from "../libs/customCropper"
import showConfirm from "../libs/showConfirm"
import formActions from "./common-form-actions";
import simpleModal from "../libs/simpleModal";

window.setChecking = function () {
    $.post('/site/groups/set-checking', {cid: cid, gid: gid})
        .then(
            data => openAlert(data.message, 'success', 2000).then(reload_window),
            (xhr, type, message) => openAlert(message, 'error', 2000)
        )
}

window.change_group_approval_status = async function () {
    try {
        let comment = $('#confirm-group-status-change textarea[name="approvalStatusComment"]');
        comment.val('');
        let action = await showConfirm('#confirm-group-status-change');
        if (action !== false) {
            window.spinner.show();
            let data = await $.ajax({
                url: '/site/groups/update-approval-status',
                type: 'POST',
                data: {
                    gid: gid,
                    cid: cid,
                    status: action,
                    comment: comment.val()
                }
            });

            await openAlert(data.message, data.success ? 'success' : 'error', 2000);
            if (data.success) {
                window.location.reload();
            }
            spinner.remove();
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.delete_group = async function () {
    try {
        const confirmed = await showConfirm('#confirm-delete-resource');
        if (confirmed !== false) {
            spinner.show();
            let data = await $.ajax({
                url: '/site/groups/delete',
                type: 'DELETE',
                data: {
                    gid: gid,
                    cid: cid,
                    action: confirmed,
                }
            })
            if (data.success) {
                await openAlert(data.message, 'success', 2000);
                window.location = data.redirect;
            } else {
                await openAlert(data.message, 'error');
                spinner.remove();
            }
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.getGroupForm = function (action, type) {
    formActions.loadForm('/site/groups/edit-form', {
        cid: window.cid,
        gid: window.gid || 0,
        action: action,
        type: type,
    }).then(modal => {
        modal.modal('show');
        const form = modal.find('form');
        const iAmLeader = form.find('input[name="EditGroup[i_am_the_leader]"]');
        if (form.length && iAmLeader.length) {
            iAmLeader.trigger('change');
        }
        tagDrag()
    }).catch(e => {
        window.openAlert(getCommonError(), 'error');
    });
}

window.getSubscribeOptionsEditor = function (type) {
    formActions.loadForm('/site/groups/edit-options', {
        gid: window.gid || 0,
        type: type,
    }).then(modal => {
        modal.modal('show');
    }).catch(e => {
        console.log(e);
        window.openAlert(getCommonError(), 'error');
    });
};

window.showTagGroups = function () {
    const modal = $('#TagGroups')
    modal.modal('show')
}

const createGallery = async function (groupId, style) {
    return new Promise((resolve) => {
        const formData = new FormData();
        formData.append('gid', groupId);
        formData.append('style', style);
        $.ajax({
            url: '/site/groups/create-group-gallery',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (result) => resolve(result.success ? 1 : 0),
            error: () => resolve(0),
        });
    });
};

// const updateDocuments = async function(form, groupId) {
//     let documents = {};
//     form.find('.file-input-widget').each(function(){
//         documents[$(this).attr('id')] = $(this).find("input[type=file]").val();
//     });
//     return Promise.resolve();
// };

const updateGalleryImages = async function (form, groupId) {
    // Important!
    if (!form.find('#gallery-wrap').length) {
        return Promise.resolve();
    }

    let galleryImages = {};
    form.trigger('event.collect.gallery.data', galleryImages);
    let promises = [], hasGallery = !galleryImages.isNewGallery;
    // console.log("collected gallery data: " + JSON.stringify(galleryImages));
    if (!hasGallery) {
        hasGallery = await createGallery(groupId, galleryImages.style || '');
        // console.log('gallery created: ', hasGallery);
    }
    if (hasGallery) {
        if (galleryImages.added.length) {
            galleryImages.added.forEach(image => {
                promises.push(new Promise((resolve, reject) => {
                    const formData = new FormData();
                    const blob = window.dataURLtoBlob(image.file);
                    const file = new File([blob], image.name, {type: image.type});
                    formData.append('image', file);
                    formData.append('file', 'image');
                    formData.append('gid', groupId);
                    formData.append('credit', image.credit);
                    $.ajax({
                        url: '/site/groups/add-gallery-image',
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: (data) => resolve(data),
                        error: (error) => reject(error),
                    });
                }));
            });
        }
        if (Object.keys(galleryImages.updated).length) {
            Object.keys(galleryImages.updated).forEach(key => {
                promises.push(new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/site/groups/update-gallery-image',
                        type: 'PUT',
                        data: {
                            imageId: key,
                            gid: groupId,
                            credit: galleryImages.updated[key]
                        },
                        success: (data) => resolve(data),
                        error: (error) => reject(error),
                    });
                }));
            });
        }
        if (galleryImages.deleted.length) {
            galleryImages.deleted.forEach(imageId => {
                promises.push(new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/site/groups/delete-gallery-image',
                        type: 'DELETE',
                        data: {
                            gid: groupId,
                            imageId: imageId
                        },
                        success: (data) => resolve(data),
                        error: (error) => reject(error),
                    });
                }));
            });
        }
    }
    return Promise.allSettled(promises);
};

const attachGroupCovers = async function (form, formData) {
    formData.delete('image3');
    try {
        formData.append('image3_url', form.find('[name=image3]').data('imageUrl'));
        formData.append('image_url', form.find('#editgroup-image').data('imageUrl'));
    } catch (e) {
    }

    const gen = function (field) {
        return new Promise(resolve => {
            const container = form.find('.field-' + field);
            if (container.data('cropper')) {
                container.data('cropper')
                    .getCroppedCanvas(window.sizes[container.data('sizes')].crop || {})
                    .toBlob(blob => {
                        formData.append(`EditGroup[${field}]`, blob)
                        resolve()
                    })
            } else {
                resolve()
            }
        })
    }
    return Promise.all([
        gen('image3'),
        ...form.find('canvas.changed').map(function () {
            return new Promise(resolve => {
                $(this)[0].toBlob(blob => {
                    formData.append($(this).data('field'), blob)
                    resolve()
                })
            })
        })
    ]);
}

const validateRefund = async function (form, formatData) {
    if (form.data('refund-noticed')) {
        return true
    }
    const dateElem = form.find('#editgroup-full_refund_until-date')
    const boolElem = form.find('#editgroup-auto_refund_enabled')
    if (dateElem.length > 0 && boolElem.length > 0 && boolElem.is(':checked') && !dateElem.val()) {
        const modal = new simpleModal({
            header: window.translate.refund_date_warning_title,
            content: window.translate.refund_date_warning_text,
        })
        modal.show()
        form.data('refund-noticed', true)
        throw 'cancelled'
    }
    return 'passed'
}

$(document).on('submit', '.edit-group-form', function (e, after = 'close') {
    e.preventDefault()
    spinner.show(window.translate.spinner_text_save || '');
    const form = $(this)
    form.trigger('beforesubmit.coing');
    let formData = new FormData(form[0]);
    formData.append('cid', cid)
    formActions.cleanForm(form);
    form.trigger('submitting.coing', formData);
    let beforeSendActions = [attachGroupCovers(form, formData), validateRefund(form, formData)];
    Promise.all(beforeSendActions).then(() => {
        form.trigger('submitted.coing');
        $.ajax({
            url: form.attr('action'),
            data: formData,
            processData: false,
            contentType: false,
            type: 'post',
            dataType: 'json'
        }).done(function (data) {
            if (data.success) {
                const modal = $('.edit-group-modal');
                if (modal.length) {
                    modal.find('.sidebar ul li[data-section]').each(function () {
                        $(this).removeClass('active').removeClass('clickable').off('click');
                    });
                    modal.find('.sidebar ul li').last().addClass('active');
                }
                let afterSuccessActions = [updateGalleryImages(form, data.gid)];
                Promise.all(afterSuccessActions).then(() => {
                    spinner.remove();
                    window.spinner.show(window.translate.spinner_text_load || '');
                    window.openAlert(data.message || '', 'success').then(() => {
                        if (after === 'continue') {
                            spinner.remove();
                        } else {
                            let doRedirect = function () {
                                let redirectTo = data.redirect || '';
                                if (redirectTo.trim().length) {
                                    window.location.href = redirectTo;
                                } else {
                                    window.location.reload();
                                }
                            }
                            window.setTimeout(doRedirect, data.delay || 0);
                        }
                    });
                });
            } else {
                formActions.applyFormErrors(
                    form,
                    data.errors || {},
                    '#{field}',
                    '.form-group,.edit-container',
                    (field, $field, $container, message) => {
                        const ticketContainer = $field.closest('tbody.ticket-form-item')
                        if (ticketContainer.length) {
                            $container = ticketContainer.find('tr.errors-container td:first')
                        }
                        const $errorp = $(`<p id="${field}-error" class="help-block help-block-error">`).text(message);
                        $container.append($errorp);
                        $field.attr('aria-describedby', field + '-error');
                    })
                    .then(() => {
                        spinner.remove();
                        window.openAlert(data.message || '', 'error');
                        form.find('.has-error :visible:focusable:first').focus();
                    });
            }
        }).fail(() => {
            spinner.remove();
            window.openAlert(getCommonError(), 'error');
        });
    }).catch(() => {
        spinner.remove();
    })

})

// Simulate the button on preview area.
$(document).on("click", ".edit-group-form .common-cropper-controls .btn-select-file", function () {
    $(this).closest('form').find('.input-group-image').click();
});

// Triggering selecting a file when clicking on preview -> will trigger file uploaded and set cropper containers sizes
$(document).on('click', '.edit-group-form [data-toggle="editImage"]', function () {
    $(this).closest('form').find('.input-group-image').trigger('click', $(this));
});
$(document).on('keyup', '.edit-group-form [data-toggle="editImage"]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).closest('form').find('.input-group-image').trigger('click', $(this));
    }
});

// Refresh image aspect ratios after selecting the file.
$(document).on('file_uploaded', '.edit-group-form [data-toggle="editImage"]', function () {
    $(this).hide();
    const container = $(this).closest('form').find('.edit-images-container.collapse')
    container.collapse('show');
    container.find('.img-cropper-container').each(function () {
        const cont = $(this).find('.img-preview-wrapper')
        const containerRatio = window.sizes[$(this).data('sizes')].containerRatio || 1
        cont.height(Math.ceil(cont.width() / containerRatio))
        window.addEventListener('resize', function (data) {
            cont.height(Math.ceil(cont.width() / containerRatio))
        })
    })
})

// Initializing cropper and slider.
$(document).on("init_cropper", ".edit-group-form .img-cropper-container", function (event) {
    const image = $(this).find('.image-preview')[0];
    const sizes = window.sizes[$(this).data('sizes')];
    const slider = $(this).find('.slider:not(.has-slider)');
    const resetBtn = $(this).siblings('.common-cropper-controls').find('.btn-reset-cropper');
    const rotateBtn = $(this).siblings('.common-cropper-controls').find('.btn-rotate-img');

    if (!$(this).data('cropper')) {
        let cropper = getCropper(image, sizes.cropperRatio || 1);
        $(this).data('cropper', cropper);
        if (slider.length > 0) {
            cropper.attachSlider(slider, slider.siblings('.btn-plus'), slider.siblings('.btn-minus'));
            slider.addClass('has-slider');
        }
        if (resetBtn.length > 0) {
            cropper.attachResetButton(resetBtn);
        }
        if (rotateBtn.length > 0) {
            cropper.attachRotateButton(rotateBtn);
        }
    } else {
        let cropper = $(this).data('cropper');
        cropper.replace(image.src, false);
    }
});

// Some sort of workaround
$(document).on('click', '.edit-images-container .input-group-image', function (event, sender = null) {
    $(this).data('last-sender', sender)
})

$(document).on('change', '.edit-images-container .input-group-image', function () {
    let uploadFile = $(this);
    let files = !!this.files ? this.files : [];
    if (!files.length || !window.FileReader) return; // no file selected, or no FileReader support

    if (/^image/.test(files[0].type)) {
        var reader = new FileReader();
        spinner.show('')
        reader.readAsDataURL(files[0]);

        reader.onloadend = function () {
            spinner.remove()
            const target = $(uploadFile.data('preview-target'))
            const result = this.result
            if (target.length > 0) {
                target.each(function () {
                    if (this.tagName === 'IMG') {
                        $(this).attr('src', result)
                    } else {
                        $(this).css('background-image', "url(" + result + ")");
                    }
                })
                if (uploadFile.data('last-sender')) {
                    $(uploadFile.data('last-sender')).trigger('file_uploaded')
                }
                uploadFile.data('last-sender', null)
                target.closest('.img-cropper-container').trigger('init_cropper')
            }
        }
    }
});

$(document).on('change', 'input[name="EditGroup[i_am_the_leader]"]', function () {
    const form = $(this).closest('form');
    let phone = form.find('input#editgroup-leader_phone');
    let cc = form.find('select#editgroup-leader_phone_cc');
    let name = form.find('input#editgroup-leader_name');

    // Reset to current users info
    if ($(this).is(':checked')) {
        if (phone.length) {
            phone.val(userPhoneNumber.trim());
            if (userPhoneNumber.trim().length > 0) {
                phone.prop('readonly', true);
            }
            if (userPhoneCc.trim().length > 0) {
                cc.val(userPhoneCc.trim()).addClass('readonly');
            } else {
                cc.val(cc.find(':first-child').val());
            }
        }
        if (name.length) {
            name.val(userName.trim());
            if (userName.trim().length > 0) {
                name.prop('readonly', true);
            }
        }
    } else {
        // Reset to last saved info (that is not current user) or empty (if new group form)
        let isNewGroup = form.find('#editgroup-group_id').val().length === 0;
        let sameUser = (phone.length) ? phone.data('reset').toString() === userPhoneNumber.toString() : false;
        if (phone.length) {
            if (!isNewGroup && !sameUser) {
                phone.val(phone.data('reset'));
                cc.val(cc.data('reset'));
            } else {
                phone.val('');
                cc.val(cc.find(':first-child').val());
            }
            phone.prop('readonly', false);
            cc.removeClass('readonly');
        }
        if (name.length) {
            if (!isNewGroup && !sameUser) {
                name.val(name.data('reset'));
            } else {
                name.val('');
            }
            name.prop('readonly', false);
        }
    }
})

$(document).on('click', '.marker-item', function () {
    $('[name="EditGroup[map_markers]"]').val($(this).attr('data-marker'));
    let dropdownBlock = $(this).closest('.marker-dropdown');
    let button = dropdownBlock.find('button');
    button.html('<img src="' + $(this).find('img').attr('src') + '"><span>' + $(this).find('span').text() + '</span>');
    button.parent().removeClass('active');
})

$(document).on('click', '.marker-dropdown-button', function () {
    $(this).parent().toggleClass('active');
});

$(document).on('click', '.status-dropdown-button', function () {
    $(this).parent().toggleClass('active');
});

$(document).on('click', '.status-item', function () {
    const widget = $(this).closest('.subscription-status');
    widget.find('.subscription-status-value').val($(this).attr('data-status'));
    let dropdownBlock = $(this).closest('.status-dropdown');
    let button = dropdownBlock.find('button');
    button.html('<div style="' + $(this).find('div').attr('style') + '"></div><span>' + $(this).find('span').text() + '</span>');
    button.parent().removeClass('active');
    const remarkFieldId = widget.data('remark_field')
    if (remarkFieldId) {
        const remarkField = $('#' + remarkFieldId)
        // Check if field is empty or filled with default value.
        if (remarkField.length && (remarkField.val() === remarkField.attr('value') || remarkField.val() === '')) {
            remarkField.val($(this).data('remark'))
            remarkField.attr('value', $(this).data('remark'))
        }
    }
})

$(document).on('click', '[data-toggle="image"]', function () {
    const $this = $(this)
    editCover({
        type: $this.data('type'),
        modalSize: $this.data('modal-size'),
        title: $this.data('modal-title'),
        submit: (modal, cropper) => {
            if (!cropper) {
                return false
            }
            const field = $this.find('canvas').data('field')
            $this.find('canvas').replaceWith(cropper.getCroppedCanvas(window.sizes[$this.data('type')].crop))
            $this.find('canvas').addClass('changed').data('field', field)
            modal.modal('hide')
            return false;
        }
    })
})

window.togglePrivacy = async function (gid, status) {
    try {
        spinner.show();
        let data = await $.ajax({
            url: '/site/groups/toggle-privacy',
            type: 'POST',
            data: {
                gid,
                status: status
            }
        });
        if (data.success) {
            await openAlert(data.message, 'success', 2000);
            window.location.reload();
        } else {
            spinner.remove();
            await openAlert(data.message, 'error');
        }
    } catch (error) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.changePriority = async function (gid, priority) {
    try {
        spinner.show();
        let data = await $.ajax({
            url: '/site/groups/change-priority',
            type: 'POST',
            data: {
                gid,
                priority
            }
        })
        if (data.success) {
            await openAlert(data.message, 'success', 2000);
            window.location.reload();
        } else {
            await openAlert(data.message, 'error');
            spinner.remove();
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.deleteSubcommunity = async function (gid, cid) {
    try {
        let confirmed = await showConfirm('#confirm-delete-resource');
        if (confirmed) {
            spinner.show();
            let data = await $.ajax({
                url: '/site/groups/unlink-community',
                type: 'DELETE',
                data: {
                    gid: gid,
                    cid: cid
                }
            })
            if (data.success) {
                await openAlert(data.message, 'success', 2000);
                window.location = data.redirect;
            } else {
                await openAlert(data.message, 'error');
                spinner.remove();
            }
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.getSubcommunityEditForm = function (action = 'new', cid = 0, gid = 0) {
    formActions.loadForm('/site/groups/edit-subcommunity-form', {
        cid: cid,
        gid: gid,
        action: action
    }).then(modal => {
        modal.modal('show')
        tagDrag()
        spinner.remove()
    }).catch(e => {
        console.log(e);
        window.openAlert(getCommonError(), 'error');
    });
}

window.getLocationGroupForm = function (cid = 0, gid = 0) {
    formActions.loadForm('/site/groups/edit-location-form', {
        cid: cid,
        gid: gid
    }).then(modal => {
        modal.modal('show')
        spinner.remove()
    }).catch(e => {
        console.log(e);
        window.openAlert(getCommonError(), 'error');
    });
}

window.saveAdminComment = async function (el, uid) {
    try {
        spinner.show();
        let comment = $('.comment-modal').find('[name=admin-comment]').val();
        let data = await $.ajax({
            url: '/site/groups/update-admin-comment',
            type: 'POST',
            data: {
                uid: uid,
                gid: gid,
                text: comment
            }
        })
        if (data.success) {
            await openAlert(data.message, 'success', 2000);
            $('.admin-comment-button.active').attr('data-comment', comment);
            closeAdminComment();
            spinner.remove();
        } else {
            await openAlert(data.message, 'error');
            spinner.remove();
        }
    } catch (message) {
        spinner.remove();
        await openAlert(getCommonError(), 'error');
    }
};

window.showCommentModal = function (event, uid, el) {
    $(el).addClass('active');
    let top = event.y;
    let left = event.x;
    let commentWindowWidth = 310;
    let commentWindowHeight = 200;
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let text = el.dataset.comment;
    let title = el.dataset.title;
    let save = el.dataset.save;
    let dismiss = el.dataset.dismiss;
    if (left + commentWindowWidth > windowWidth) {
        left = windowWidth - commentWindowWidth;
    }

    if (top + commentWindowHeight > windowHeight) {
        top = windowHeight - commentWindowHeight;
    }

    $('body').append('<div class="comment-modal" style="top: ' + top + 'px; left: ' + left + 'px"> <div>' +
        '<h3>' + title + '</h3>' +
        '<textarea name="admin-comment" rows="3">' + text + '</textarea>' +
        '<button type="button" class="btn back-btn" onClick="closeAdminComment(); return false;">' + dismiss + '</button>' +
        '<button type="button" class="btn btn-main" onClick="saveAdminComment(this,' + uid + '); return false;">' + save + '</button>' +
        '</div></div>');
}


window.closeAdminComment = function () {
    $('.admin-comment-button').removeClass('active');
    $('.comment-modal').remove();
}

$(document).mouseup(function (e) {
    let container = $(".comment-modal button, .comment-modal");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.admin-comment-button').removeClass('active');
        $(".comment-modal").remove();

    }
});

$(document).on('click', '[data-group-action=info]', async function () {
    const modal = new simpleModal({
        id: 'GroupActions',
        header: false,
        content: await $.ajax(`/site/groups/info/${gid}`),
        small: true,
    })
    modal.show()
})

$(document).on('click', '[data-group-action=recurring]', async function () {
    const url = $(this).attr('data-src');
    const modal = new simpleModal({
        id: 'RecurringEvents',
        header: false,
        content: `<iframe src=${url} class="embedd-field"></iframe>`,
    })
    modal.attach()
    window.spinner.show()
    const listener = e => {
        console.debug(e)
        if (e.origin !== window.JS_MANAGEMENT_URL) {
            console.warn("origin mismatch: " + e.origin)
            return
        }
        try {
            if (e.data.type === 'recurring-event-options-loaded') {
                modal.show()
                // 300 is to make transitions smooth
                setTimeout(() => window.spinner.remove(), 300)
            }
        } catch (e) {
            console.warn(e)
        }
    }
    window.addEventListener('message', listener, false);
    modal.$.on('closed.cc.modal', function () {
        window.removeEventListener('message', listener);
        window.location.reload()
    })
})
